<template>
  <q-dialog v-model="showDialog" persistent>
    <q-card class="coaching-session-survery-popup" style="background-color: #fff !important;">
      <q-card-section>
        <div class="row items-center">
          <div class="col">
            <div class="ei-font-size-17 text-ei-grey">30 Second Survey</div>
          </div>
          <div class="col-auto desktop-only"><q-btn icon="close" flat round dense @click="closePopup()" /></div>
        </div>
      </q-card-section>

      <div class="dialog-separator"></div>

      <q-card-section>
        <div class="flex justify-center">
          <div class="servery-icon q-mb-md">
            <div class="full-height flex flex-center">
              <span
                style="font-size: 25px;"
                class="ei-icons ei-icon-noun-play"
              ></span>
            </div>
          </div>
        </div>

        <div class="ei-font-size-18 q-mb-md rubik-light">
          <span class="ei-grey-2">Please complete the survey for the past Coaching Session: </span>{{surveyNotification.session_name}}
        </div>

      </q-card-section>

      <div class="dialog-separator"></div>

      <q-card-actions class="action-button" align="right">
        <a
          target="__blank"
          class="btn-not-now mobile-full-width rubik-light border-radius-6 q-py-sm q-px-md"
          unelevated
          @click="closePopup()"
        >Not Now</a>

        <a
          :href="surveyNotification.survey_link"
          @click="closeAfterRedirect()"
          target="__blank"
          class="btn-survey-link bg-primary text-white mobile-full-width rubik-light border-radius-6 q-py-sm q-px-md"
          unelevated
        >Take Survey</a>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {LocalStorage as SessionStorage} from "quasar";
import firebase from "firebase/compat/app";

export default {
  props: {
    surveyNotification: Object,
    callback: Function
  },
  watch: {
    surveyNotification: {
      handler(newValue) {
        console.log("SurveyNotificationPopup received updated surveyNotification:", newValue);
      },
      deep: true,
    },
  },
  data() {
    return {
      showDialog: true
    };
  },
  computed: {
    ...mapGetters("auth", ["authUser"]),
  },
  methods: {
    ...mapActions("home", ["getHomePageData"]),
    closePopup() {
      let survey_popup_obj = this.surveyNotification;
      if(survey_popup_obj?.retry_count && survey_popup_obj.retry_count > 0 ) {
        let retry_count = survey_popup_obj.retry_count -=1;
        const db = firebase.firestore();
        db.collection("users").doc(this.authUser._id).update("survey_popup_obj.retry_count", retry_count);
        this.getHomePageData();
      }
      this.showDialog = false;
      this.callback(false);
    }, 
    closeAfterRedirect() {
      this.showDialog = false;
      this.callback(false);
    }
  },
  mounted() {
    SessionStorage.set('survey_popup_retry', true);
    this.showDialog = true;
  }
};
</script>

<style scoped>
.coaching-session-survery-popup {
  width: 50% !important;
}

.btn-not-now {
  cursor: pointer;
  border: 1px solid #14add2 !important;
  color: #000 !important;
  margin-right: 15px;
}


@media only screen and (max-width: 768px) {
  .coaching-session-survery-popup {
    width: 90% !important;
  }

  .btn-not-now {
    margin-right: 0 !important;
    margin-top: 7px !important;
    text-align: center;
    border: none !important;
  }

  .btn-survey-link{
    text-align: center;
    max-width: 75%;
  }

  .action-button{
    flex-flow: column-reverse;
  }

}



</style>
